// LEGACY: Uses @ion/components. New code should use @metarouter-private/mr-mui components instead.
import React from 'react';
import PropTypes from 'prop-types';

import { useTheme } from '@mui/material/styles';

import { useUpdatePipeline } from '@ion/api';
import { MrDataTable } from '@ion/components';

import { useConsentModeEnabled } from 'app/components/consent-mode-select/GatedConsentModeSelect';
import { FEATURE_FLAGS } from 'app/launch-darkly/featureFlags';
import isFeatureEnabled from 'app/launch-darkly/is-feature-enabled';

import { usePipelineIntegrationModalContext } from './context/pipeline-integration-modal-context';
import PipelineIntegrationsTableTitle from './title/PipelineIntegrationsTableTitle';
import buildTableData, { INTEGRATION_TYPES } from './buildTableData';
import buildViewableDatatableProps from './buildViewableDataTableProps';
import { PIPELINE_MODAL_OPTIONS, PipelineModal } from './pipeline-modal/PipelineModal';
import IntegrationActivationModal from './IntegrationActivationModal/IntegrationActivationModal';
import buildConditionalRowStyles from './buildConditionalRowStyles';
import { useFlags } from 'launchdarkly-react-client-sdk';

const PipelineIntegrationsTable = ({ pipeline, pipelineIntegrations, deployedRevisions }) => {
  const theme = useTheme();
  const featureFlags = useFlags();
  const hasConsentMvp = isFeatureEnabled({ featureFlags, flagName: FEATURE_FLAGS.configurableConsentMvp });
  const { consentModeEnabled: hasConsentMode } = useConsentModeEnabled();
  const { onOpenModal } = usePipelineIntegrationModalContext();
  const [, { isAllowed: canTakeActions }] = useUpdatePipeline();
  const tableData = buildTableData({ deployedRevisions, pipelineIntegrations });

  const onClickIntegrationName = row => {
    if (row.type === INTEGRATION_TYPES.MANAGED) {
      onOpenModal(PIPELINE_MODAL_OPTIONS.editIntegration, row);
    }
  };
  const viewableProps = buildViewableDatatableProps({
    canTakeActions,
    onRowClicked: onClickIntegrationName,
    hasConsentMvp,
    hasConsentMode,
  });

  return (
    <>
      <MrDataTable
        title={<PipelineIntegrationsTableTitle pipeline={pipeline} tableData={tableData} />}
        data={tableData}
        conditionalRowStyles={buildConditionalRowStyles(theme)}
        {...viewableProps}
      />
      <PipelineModal />
      <IntegrationActivationModal />
    </>
  );
};

PipelineIntegrationsTable.propTypes = {
  pipeline: PropTypes.object.isRequired,
  pipelineIntegrations: PropTypes.array,
  deployedRevisions: PropTypes.array.isRequired,
};

export default PipelineIntegrationsTable;
